import { render } from "./ExchangeCard.vue?vue&type=template&id=7dce323c&scoped=true"
import script from "./ExchangeCard.vue?vue&type=script&lang=js"
export * from "./ExchangeCard.vue?vue&type=script&lang=js"

import "./ExchangeCard.vue?vue&type=style&index=0&id=7dce323c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dce323c"]])

export default __exports__